const footerConfig = {
    label: 'Footer',
    config: {
      headline: 'Kontaktieren Sie uns',
      contact: {
        name: null,
        department: 'Departement Fortschritt und Digitales',
        role: 'Musterstrasse 15',
        division: '',
        title: null,
        further: null,
        firstname: null,
        lastname: null,
        address: '',
        zip: '5000',
        locality: 'Aarau',
      },
      contactlinks: [
        {
          title: '+41 (0)62 835 35 35',
          text: '+41 (0)62 835 35 35',
          url: 'tel:+41628352362',
          type: 'tel',
        },
        {
          title: 'E-Mail',
          text: 'E-Mail',
          url: 'mailto:info@ag.ch',
          type: 'email',
        },
      ],
    },
    imprintLinks: [
      {
        title: 'Kontakt',
        url: 'https://www.ag.ch/de/ueber-uns/kontakt',
      },
      {
        title: 'Impressum',
        url: 'https://www.ag.ch/de/ueber-uns/impressum',
      },
      {
        title: 'Rechtliche Hinweise',
        url: 'https://www.ag.ch/de/ueber-uns/rechtliche-hinweise',
      },
      {
        title: 'Barrierefreiheit',
        url: 'https://www.ag.ch/de/ueber-uns/barrierefreiheit',
      },
    ],
    metaLinks: [
      {
        title: 'Jobs & Karriere',
        text: 'Jobs & Karriere',
        url: 'https://www.ag.ch/de/ueber-uns/jobs-karriere',
      },
      {
        title: 'Medien',
        text: 'Medien',
        url: 'https://www.ag.ch/de/aktuell/medien',
      },
      {
        title: 'Aktuell',
        text: 'Aktuell',
        url: 'https://www.ag.ch/de/aktuell',
      },
      {
        title: 'Themen',
        text: 'Themen',
        url: 'https://www.ag.ch/de/themen',
      },
      {
        title: 'Dienstleistungen',
        text: 'Dienstleistungen',
        url: 'https://www.ag.ch/de/smartserviceportal#/',
      },
      {
        title: 'Behördenverzeichnis',
        text: 'Behördenverzeichnis',
        url: 'https://www.ag.ch/de/ueber-uns/kontakt/behoerdenverzeichnis',
      },
    ],
  };

  export default footerConfig;